const Shader_BreatheButton = {
    vert: `uniform mat4 matrix_viewProjection;
    uniform mat4 matrix_model;
    
    // Additional inputs
    attribute vec3 vertex_position;
    attribute vec2 vertex_texCoord0;
    
    // Additional shader outputs
    varying vec2 vUv0;
    
    void main(void) {
        // UV is simply passed along as varying
        vUv0 = vertex_texCoord0;
    
        // Position for screen-space
        gl_Position = matrix_model * vec4(vertex_position, 1.0);
        gl_Position.zw = vec2(0.0, 1.0);
    }`,
    frag: `
    precision mediump float;

    varying vec2 vUv0;

    uniform float uTime;
    uniform vec3 col;
    uniform float opacity;
    uniform float rate;
    uniform float amp;
    
    
    //- - - - - 
    vec3 mod289(vec3 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec2 mod289(vec2 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec3 permute(vec3 x) { return mod289(((x*34.0)+1.0)*x); }

float snoise(vec2 v) {
    const vec4 C = vec4(0.211324865405187,  // (3.0-sqrt(3.0))/6.0
                        0.366025403784439,  // 0.5*(sqrt(3.0)-1.0)
                        -0.577350269189626,  // -1.0 + 2.0 * C.x
                        0.024390243902439); // 1.0 / 41.0
    vec2 i  = floor(v + dot(v, C.yy) );
    vec2 x0 = v -   i + dot(i, C.xx);
    vec2 i1;
    i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
    vec4 x12 = x0.xyxy + C.xxzz;
    x12.xy -= i1;
    i = mod289(i); // Avoid truncation effects in permutation
    vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
        + i.x + vec3(0.0, i1.x, 1.0 ));

    vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);
    m = m*m ;
    m = m*m ;
    vec3 x = 2.0 * fract(p * C.www) - 1.0;
    vec3 h = abs(x) - 0.5;
    vec3 ox = floor(x + 0.5);
    vec3 a0 = x - ox;
    m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
    vec3 g;
    g.x  = a0.x  * x0.x  + h.x  * x0.y;
    g.yz = a0.yz * x12.xz + h.yz * x12.yw;
    return 130.0 * dot(m, g);
}
    
    
    
    float circle(in vec2 _st, in float _radius){
        vec2 off = _st + (uTime*rate);
        vec2 dist = _st-vec2(0.5) - (snoise(off)*amp);
        return 1.-smoothstep(_radius-(_radius*0.01),
                             _radius+(_radius*0.01),
                             dot(dist,dist)*4.0);
    }

    void main(){
        vec2 uv = vUv0 - vec2(0.5,0.5);
        float circ = circle((uv*1.5)+vec2(0.5,0.5), 1.0);
        gl_FragColor=vec4(col, circ*opacity);
    }`
}
export { Shader_BreatheButton };